import React from "react";

import { Box } from "grommet";

export const ListItem = props => (
  <Box
    tag="li"
    pad="small"
    direction="row-responsive"
    align="center"
    {...props}
  />
);
